type TParams = {
  routeName: string;
};

export const navigateHandle = ({ routeName }: TParams): void => {
  const destinationElement = document.querySelector<HTMLDivElement>(routeName);

  if (destinationElement) {
    window.scrollTo({
      behavior: 'smooth',
      // We want element to be scrolled below the header
      top: destinationElement.offsetTop,
    });
  }
};
